import { render, staticRenderFns } from "./PaymentStatus.vue?vue&type=template&id=1da348c7&scoped=true"
import script from "./PaymentStatus.vue?vue&type=script&lang=js"
export * from "./PaymentStatus.vue?vue&type=script&lang=js"
import style0 from "./PaymentStatus.vue?vue&type=style&index=0&id=1da348c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da348c7",
  null
  
)

export default component.exports